import { getFormDataFromObject } from '@cvt/helpers/form';
import { camelizeObject } from '@cvt/helpers/object';

export const mapMediaUploadResponse = (data: Tributes.MediaUploadResponseApi): Tributes.MediaUploadResponse => {
  const media = camelizeObject<Tributes.MediaUploadResponse>(data);
  return {
    ...media,
  };
};

export const mapMediaUploadCrudData = (data: Tributes.MediaUploadRequest): FormData => {
  const formData = getFormDataFromObject({
    media: typeof data.media === 'string' ? undefined : data.media,
  });

  return formData;
};
